module.exports = __webpack_public_path__ + "img/1518489032.37df51a7.jpg";